import React, { useEffect, useState } from 'react';
import { TurnstileChallenge } from '../survey/TurnstileChallenge';
import { UI_TEXT } from '../../config/ui-text';
import {
  cancelHumanVerification,
  resolveHumanVerification,
  useHumanVerificationTicket,
} from '../../features/auth/humanVerificationStore';

/** Mounted once at the app root; opens whenever postJsonWithChallenge needs a token. */
export const HumanVerificationDialog: React.FC = () => {
  const ticket = useHumanVerificationTicket();
  const pending = ticket > 0;
  const [loadError, setLoadError] = useState(false);
  const copy = UI_TEXT.AUTH.HUMAN_VERIFICATION;

  useEffect(() => {
    // Per TICKET, not per pending: a fresh waiter deserves a fresh attempt at the widget, even if
    // the previous one failed to load while the dialog stayed open.
    setLoadError(false);
  }, [ticket]);

  if (!pending) return null;
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={copy.TITLE}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
    >
      <div className="w-full max-w-md">
        {loadError ? (
          <div className="bg-white rounded-lg shadow-lg p-8 text-center">
            <p className="text-gray-700">{copy.LOAD_ERROR}</p>
          </div>
        ) : (
          <TurnstileChallenge
            // Remounts the widget as the queue advances, so each waiter gets its own single-use
            // token. Without the key React keeps one widget across the whole queue and every
            // waiter after the first blocks for ever.
            key={ticket}
            layout="inline"
            copy={copy}
            onVerified={resolveHumanVerification}
            onError={() => setLoadError(true)}
          />
        )}
        <button
          type="button"
          onClick={cancelHumanVerification}
          className="mt-3 w-full py-3 text-sm text-gray-600 hover:text-gray-900"
        >
          {copy.CANCEL}
        </button>
      </div>
    </div>
  );
};
